import React from 'react';
const ContactSection = ({ contact_section_content, contact_section_title, contact_section_cta_button }) => {
    return (
        <>
            <div className="information-box with-button text-center find-position">
                <div className="container">
                    <div className="intro-box p-18">
                        {
                            contact_section_title &&
                            <h2 className="heading">{ contact_section_title }</h2>
                        }
                        {
                            contact_section_content &&
                            <p>{ contact_section_content }</p>
                        }
                        {
                            contact_section_cta_button &&
                            <div className="button-box">
                                <a href={ contact_section_cta_button.url }
                                    className='button button-outline big-size'
                                    target={ contact_section_cta_button.target !== "" ? "_blank" : "_self" }>
                                    { contact_section_cta_button.title }
                                </a>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactSection;